// extracted by mini-css-extract-plugin
module.exports = {"video_background_container":"VideoBackground_video_background_container__2OCHc","video_background":"VideoBackground_video_background__F9uyQ"};